module.exports = __webpack_public_path__ + "img/eth.cb9b3252.png";